<template>
  <BModal
    active
    has-modal-card
    class="user-bulk-upload"
    @close="closeModal()"
  >
    <form
      class="modal-card"
      @submit.prevent="create"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Carga Masiva de Usuarios
        </p>
      </header>
      <section class="modal-card-body">
        <BField :class="{ 'has-background-primary': fileName }">
          <BUpload
            v-model="csv"
            accept=".csv"
            :disabled="loading"
            :loading="loading"
            multiple
            drag-drop
            @input="onInput('csv', $event)"
          >
            <section
              class="section"
            >
              <div
                class="content has-text-centered"
                :class="{ 'has-text-white': fileName }"
              >
                <p>
                  <BIcon
                    :icon="fileName ? 'check' : 'upload'"
                    size="is-large"
                  />
                </p>
                <p>
                  {{ fileName || 'Subir archivo' }}
                </p>
              </div>
            </section>
          </BUpload>
        </BField>

        <a
          class="button is-info is-fullwidth"
          :href="isTelumCsvPath"
          :download="isTelumCsvFile"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
        >
          <BIcon
            icon="cloud-download"
          />
          <span>
            Descargar ejemplo
          </span>
        </a>
      </section>
      <footer class="modal-card-foot">
        <button
          type="submit"
          class="button is-primary"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
        >
          Subir Usuarios
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>

export default {
  name: 'UsersCsvLoad',
  data() {
    return {
      loading: false,
      csv: null,
      fileName: null,
    };
  },
  computed: {
    isTelumCsvFile() {
      return this.$store.state.ui.isTelum ? 'usersTelum.csv' : 'users.csv';
    },
    isTelumCsvPath() {
      return this.$store.state.ui.isTelum ? '/usersTelum.csv' : '/users.csv';
    },
  },
  methods: {
    onInput(name, event) {
      const [file] = event;
      this.fileName = file.name;

      this.$store.commit('users/setValue', {
        accessor: name,
        value: file,
      });
    },

    async create(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('users/csvLoad');
        this.$router.push({ name: 'UserBulkLoadStatus' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
    closeModal() {
      this.$emit('close', true);
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 769px) {
  form {
    max-width: 400px;
  }
}
</style>

<style>
.user-bulk-upload .upload-draggable.is-primary {
  width: 100%;
}
</style>
